import { render, staticRenderFns } from "./zonaCustom.vue?vue&type=template&id=57e2b319&scoped=true"
import script from "./zonaCustom.vue?vue&type=script&lang=js"
export * from "./zonaCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e2b319",
  null
  
)

export default component.exports